export const TURN_ON_AUTOSYNC_SUPPORT_DOC_URL = `https://bamboohr.screenstepslive.com/s/20760/m/82546/l/1258197-what-changes-will-i-see-in-traxpayroll-with-autosync`;
